import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import AuthenticationService from '../service/AuthenticationService';
import EventBus from "../common/EventBus";
import CompanyService from '../service/CompanyService';
//import { useHistory } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import utils from '../constants/utils';
import AccountService from '../service/AccountService';
import AuthService from '../security/AuthService';
import PasswordChecklist from "react-password-checklist"
import Constants from '../constants/Constants';

import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import FileService from '../service/FileService';

const CustomAddImage = (props) => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [selectedImage, setSelectedImage] = useState();


    const [file, setFile] = useState();

    let { usermail, verificationToken, action } = useParams();

    console.log("CustomAddImage props: ", props);





    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }



    useEffect(() => {

    }, []);




    const onFileSelect = (param) => {
        setFile(param.files[0])
        setSelectedImage()
        console.log("onFileSelect", param);
    };


    const onSelectedImage = (param) => {
        setSelectedImage(param)
        setFile();
        console.log("onSelectedImage", param);
    };




    const checkButtonStatus = () => {

        console.log("checkButtonStatus", file)
        if (file?.objectURL?.length > 0) {
            return false;
        }
        if (selectedImage?.length > 0) {
            return false;
        }

        return true;

    }

    const onClear = () => {
        setFile(null);
        setSelectedImage(null);

    }
    const onAddArtWork = async () => {
        console.log("onAddArtWork",file,"d***",selectedImage)
        let _imageInfo;
        if (file) {
            setDisplayLoadingDialog(true);

            const reader = new FileReader();
            let blob = await fetch(file.objectURL).then(r => r.blob()); //blob:url
            reader.readAsDataURL(blob);
            reader.onloadend = function () {

                const base64data = reader.result;

                _imageInfo={ file: base64data, fileName: file.name, key: props.imageKey, code: props.code, upploadFlag: true,fileType:props.fileType };

                props.setImage(_imageInfo);
                onClear();
                props?.setDialogVisible(false);
                console.log("onAddArtWork _imageInfo",_imageInfo)
            }

        } else if (selectedImage) {
            _imageInfo={ file: selectedImage, fileName: "selectedImage", key: props.imageKey, code: props.code, upploadFlag: false,fileType:props.fileType };
            props.setImage(_imageInfo);
            onClear();
            props?.setDialogVisible(false);
            console.log("onAddArtWork _imageInfo",_imageInfo)
        }
        

       
    }


    /*  console.log("onAddArtWork");

      props.setImage(file)

      if ( file) {
          setDisplayLoadingDialog(true);

          const reader = new FileReader();
          let blob = await fetch(file.objectURL).then(r => r.blob()); //blob:url
          reader.readAsDataURL(blob);
          reader.onloadend = function () {

              const base64data = reader.result;

              const apiParams = { file: base64data, fileName: file.name, key: props.imageKey, code: props.code };
              console.log("apiParams",apiParams," *** ",props);

              FileService.uploadProfile(apiParams).then(

                  (response) => {

                      console.log("onAddArtWork", response);

                      if (response?.data?.error || response?.data?.data?.status==='ERROR') {
                          setDisplayLoadingDialog(false);

                          let _detail = response.data.error?.innerExceptionMessage;
                          if (t(_detail)) {
                              _detail = t(_detail);
                          }


                          props.toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                      } else {
                          console.log("onAddArtWork", response);

                          setDisplayLoadingDialog(false);
                          onClear();

                          props?.setDialogVisible(false);



                          let _detail = t('add_artwork_success')

                          props.toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                      }
                  },
                  (error) => {
                      setDisplayLoadingDialog(false);

                      const _content =
                          (error.response &&
                              error.response.data &&
                              error.response.data.message) ||
                          error.message ||
                          error.toString();

                      console.log(_content);

                      if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                          EventBus.dispatch("logout", props);

                      } else {
                          props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                      }
                  }
              );
          }
      } else {
          props.toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_detail"), life: 5000 });

      }


  }*/



    const chooseOptions = { icon: 'fas fa-cloud-arrow-up file-upload-icon p-button-header', iconOnly: true, padding: 0 };

    const renderArtworkPanel = () => {

        return (
            <div className="col-12 md:col-12 flex justify-content-center " >
                <div className=" register-content  w-12   p-3 ">
                    <div className="grid justify-content-center " >
                        <div className="flex align-items-center align-content-center justify-content-center col-12 md:col-4 file-upload-content-select"
                            style={{
                                backgroundImage: `url(${file?.objectURL})`,
                                borderRadius: 20,
                                backgroundColor: !file ? '#B0B0B0' : 'white',
                                boxShadow: file?.objectURL ? '5px 6px 8px #4C4C4C' : '',

                            }}>

                            {!file &&
                                <FileUpload mode="basic" name="demo[]"
                                    accept="image/*" maxFileSize={10000000}
                                    onSelect={onFileSelect}
                                    customUpload
                                    chooseOptions={chooseOptions}


                                />
                            }

                        </div>
                        {props.loadDefaultImages && Constants.coverImages.map((image, index) => {
                            //
                            return (
                                <div key={index} className="flex align-items-center align-content-center justify-content-center col-12 md:col-4 file-upload-content-select-temp"
                                >
                                    <img key={index} src={image.image_path} className='file-upload-content-select-temp-image'
                                        onClick={() => onSelectedImage(image.image_path)}

                                        style={{
                                            borderColor: image.image_path === selectedImage ? '#5a5e7f' : '#ffffff',
                                            borderWidth: 2,
                                            boxShadow: image.image_path === selectedImage ? '5px 6px 8px #4C4C4C' : '',
                                        }}
                                    >
                                    </img>
                                </div>
                            )
                        }
                        )
                        }


                    </div>
                </div>
            </div>

        )



    }



    /* IMAGE UPLOAD*/
    const renderButton = () => {


        return (
            <div className=" flex justify-content-between p-1 w-12 pr-3 pl-3" >
                <div className=" w-fit ">
                    <Button label={t("global_btn_clear")} className="p-button-rounded mr-2 mb-2"
                        onClick={() => onClear()}

                    />

                </div> <div className=" w-fit ">

                    <Button label={t("global_btn_ok")} className="p-button-rounded mr-2 mb-2" disabled={checkButtonStatus()}
                        onClick={() => onAddArtWork()}

                    />
                </div>

            </div>
        )

    }
    return (
        <div className="grid p-fluid flex justify-content-center p-2" style={{ maxWidth: 650 }}>
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>

            {renderArtworkPanel()}

            {renderButton()}


        </div>
    )
}

export default CustomAddImage;